import DeleteButton from './DeleteButton.component';

export default DeleteButton;
